import React, { useState } from "react";
import TrendingNewsModal from "../../../components/ui/popup/finances/TrendingNewsModal";

function TrendingNewsCard({ item }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!item) return null;

  const { title, image, source_name } = item;

  // Truncate title to max 80 characters including spaces
  const truncatedTitle =
    title && title.length > 80 ? `${title.slice(0, 80)}...` : title;

  const handleCardClick = (e) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  return (
    <>
      <div
        role="button"
        tabIndex={0}
        className="trending-news-card"
        onClick={handleCardClick}
      >
        <div
          className="trending-news-card-image"
          style={{
            backgroundImage: `url("${image}")`,
          }}
        />

        <div className="trending-news-card-content">
          {title && (
            <h4 className="trending-news-card-title">{truncatedTitle}</h4>
          )}

          {source_name && (
            <span className="trending-news-card-source">{source_name}</span>
          )}
        </div>
      </div>

      {isModalOpen && (
        <TrendingNewsModal item={item} setIsModalOpen={setIsModalOpen} />
      )}
    </>
  );
}

export default TrendingNewsCard;
